<script>
  export let voteLabel = 'votes';
  /** @type {boolean} */
  export let isBallotMeasure
  /** @type {boolean} */
  export let hasParties
  /** @type {boolean} */
  export let face

</script>

<thead>
  <tr>
    <th scope="col" colSpan={face?2:1} class="contest__candidate-header">
      {isBallotMeasure ? 'Support' : 'Candidate'}
    </th>
    {#if !isBallotMeasure && hasParties}
      <th scope="col" colSpan={1} class="contest__candidate-header">Party</th>
    {/if}
    <th scope="col" class="contest__candidate-header text-right">
      {voteLabel}
    </th>
    <th scope="col" class="contest__candidate-header text-right">
      <span class="invisible">%</span>
    </th>
  </tr>
</thead>
